//urls
// const UROOT_API_DEBUG = 'http://localhost:7070';
// export const UROOT_API = 'http://localhost:7070';
// export const UROOT_API = 'https://mvpapipp-staging.herokuapp.com';
// export const UROOT_API = 'https://mvpapipp.herokuapp.com';
export const UROOT_API = process.env.REACT_APP_BASE_API_URL || 'http://localhost:7070';
export const URANDOM_USER = 'https://randomuser.me/api/?nat=us&inc=login';
// let UROOT_API = '';
// if ('DEBUG' in process.env) {
//   UROOT_API = UROOT_API_DEBUG;
// } else {
//   UROOT_API = UROOT_API_HEROKU;
// }
// console.log(process.env);
// console.log(UROOT_API);

//headers
export const API_HEADERS = {
  'Content-Type': 'application/json',
  'X-Auth-User': '',
};

export const GENERIC_HEADER = {
  'Content-Type': 'application/json',
}



// WEBPACK FOOTER //
// ./src/actions/api_const.js